export default __webpack_public_path__ + "static/media/model-cost-functions.57dc6e09.md";